import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { NgRatingBarModule } from 'ng-rating-bar';

import { CarrierFeedbacksComponent } from './carrier-feedbacks/carrier-feedbacks.component';

const components = [CarrierFeedbacksComponent];

@NgModule({
	declarations: [components],
	imports: [CommonModule, CoreModule, NgRatingBarModule],
	exports: [...components],
})
export class CarrierFeedbackModule {}
